import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=c958426a"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"
import style0 from "./Promos.vue?vue&type=style&index=0&id=c958426a&prod&lang=scss&module=true"
import style1 from "./Promos.vue?vue&type=style&index=1&id=c958426a&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports